import * as React from 'react';
import './LinkButton.scss';
import { Link } from '@bit/redsky.framework.rs.996';
import Button from '@bit/redsky.framework.rs.button';
import Label from '@bit/redsky.framework.rs.label';
import Icon from '@bit/redsky.framework.rs.icon';

interface LinkButtonProps {
	path: string;
	label: string;
	buttonSecondary?: boolean;
	className?: string;
	iconName?: string;
	onClick?: () => void;
}

const LinkButton: React.FC<LinkButtonProps> = (props) => {
	return (
		<Link path={props.path} className={`rsLinkButton ${props.className || ''}`} onClick={props.onClick}>
			<Button look={!props.buttonSecondary ? 'containedPrimary' : 'containedSecondary'}>
				<Label variant={'caption'}>{props.label}</Label>
				{!!props.iconName && <Icon iconImg={props.iconName} />}
			</Button>
		</Link>
	);
};

export default LinkButton;
